import React from 'react';
const painPoints: string[] = ['Despiertas cansada, como si no hubieras dormido nada.', 'Sientes que tu cuerpo grita lo que tu mente calla.', 'Vives con dolores que los médicos llaman "solo estrés".', 'Buscas una solución natural que no sea otra pastilla.'];
export function Vsl() {
  return <section className="px-5 py-14 sm:px-8" style={{
    background: 'linear-gradient(160deg, #0c0c0c 0%, #2d1b4e 100%)'
  }} data-id="element-127" data-mp="2aywwhsr283uh">
      <div className="mx-auto max-w-3xl text-center" data-id="element-128" data-mp="2fxgmc48rxzs4">
        <p className="flex items-center justify-center gap-2 text-[11px] font-black uppercase tracking-[0.12em] text-white/85 sm:text-[12px]" data-id="element-129" data-mp="2kw1my4rxulh3">
          <span aria-hidden="true" className="live-dot h-2.5 w-2.5 rounded-full bg-red-500" data-id="element-130" data-mp="2oz7ncvsddifn" />
          Mira esto antes de que el contador llegue a cero
        </p>

        <div className="mt-4 overflow-hidden rounded-xl border-2 border-gold" style={{
        boxShadow: '0 0 34px rgba(26, 74, 46, 0.85), 0 0 0 1px rgba(201,168,76,0.25)'
      }} data-id="element-131" data-mp="ulgkcf4jpwt6">
          <video className="block aspect-video w-full bg-black" src="https://res.cloudinary.com/lkfj1jku/video/upload/v1787190134/VSL_manual_Autosanacion.mp4" controls playsInline preload="metadata" data-id="element-132" data-mp="2b4idzt466n2v">
            Tu navegador no soporta la reproducción de video.
          </video>
        </div>

        {/* Pain points — the avatar's bridge */}
        <div className="mt-11" data-id="element-133" data-mp="2u11ddqp68wm8">
          <h2 className="font-display text-[18px] font-normal italic tracking-wide text-gold/90 sm:text-[22px]" data-id="element-134" data-mp="2u005fv3gcq8q">
            ¿Te sientes identificada con esto?
          </h2>
          <ul className="mt-5 grid gap-3 text-left sm:grid-cols-2" data-id="element-135" data-mp="2l03d9jhut98x">
            {painPoints.map(point => <li key={point} className="flex items-start gap-3 rounded-lg border border-white/10 bg-white/[0.04] px-4 py-3" data-id="element-136" data-mp="2g4nz0qfxpbbz">
                <span aria-hidden="true" className="mt-0.5 text-[13px] text-gold" data-id="element-137" data-mp="14mmydy3ygo3x">
                  ✦
                </span>
                <span className="text-[14px] leading-snug text-white/85 sm:text-[15px]" data-id="element-138" data-mp="162h5r2758sq7">
                  {point}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}